/**
 * 简体中文。
 *
 * 键名来自 `cs.js`。缺了哪个键，就显示英文文本（英文也没有就显示捷克文），
 * 这样空缺一眼就能看出来。
 *
 * 这份翻译还没有讲中文的跨性别者读过。跨性别相关的词汇和称呼在这里
 * 比别处更要紧：如果哪里听着不对，告诉我们，我们就改。
 */
const zh = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': '返回',
  'obecne.hledat': '搜索',
  'obecne.nacitani': '加载中…',
  'obecne.zrusit': '取消',
  'obecne.ulozit': '保存',
  'obecne.odeslat': '发送',
  'obecne.vice': '显示全部',
  'obecne.jazyk': '语言',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': '为跨性别社群准备的安全空间，你可以在这里坦白地说话、寻找帮助，也能感到有人支持。',
  'auth.prihlaseni': '登录',
  'auth.registrace': '注册',
  'auth.email': '电子邮箱',
  'auth.heslo': '密码',
  'auth.emailPriklad': 'you@example.com',
  'auth.prihlasitSe': '登录',
  'auth.prihlasuji': '正在登录…',
  'auth.zapomenuteHeslo': '忘记密码了？',
  'auth.presGoogle': '用 Google 登录',
  'auth.spatneUdaje': '邮箱或密码不对',
  'auth.uspech': '已登录。',
  'auth.googleChyba': 'Google 登录没有成功',
  'auth.obnoveniHesla': '重置密码',
  'auth.obnoveniOdeslano': '如果这个邮箱已注册，你会收到一封重置密码的链接。',
  'auth.zpetNaPrihlaseni': '回到登录',
  'auth.odeslatOdkaz': '发送重置链接',
  'auth.obnoveniChyba': '邮件没能发出去。请再试一次。',

  // druhý krok přihlášení
  'auth.jesteKod': '还差一步：你的验证码',
  'auth.jesteKodPopis': '打开你的验证器应用，抄下 Bloom 那一栏显示的六位数字。',
  'auth.kod': '验证码',
  'auth.zalozniKodNapoveda': '手机不在手边？输入你开启此功能时保存的备用码之一。',
  'auth.potvrdit': '确认',
  'auth.overuji': '检查中…',
  'auth.kodNesedi': '这个验证码不对',
  'auth.zalozniDochazeji': (p) => `你只剩 ${p.pocet} 个备用码了。请在个人资料里生成新的。`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': '如何把 Bloom 装到手机上',
  'auth.krokyAndroid': [
      '用 Chrome 打开这个页面',
      '点右上角的三点图标（⋮）',
      '选择“添加到主屏幕”或“安装应用”',
      '确认安装',
    ],
  'auth.krokyIos': [
      '用 Safari 打开这个页面',
      '点下方工具栏的分享图标（□↑）',
      '往下滚动，选择“添加到主屏幕”',
      '点“添加”确认',
    ],
  'auth.seznamChranene': [
      { silne: '关于成员的一切都不公开。', text: '个人资料、故事、互助信息、提问、照片和头像只提供给已登录的人。没有账号，这些都无法下载或抓取。' },
      { silne: '没人知道你的密码', text: '——我们也不知道。它以 bcrypt 摘要保存，无法从中还原出原始密码。' },
      { silne: '私信和附件是加密的', text: '（AES + 完整性校验）保存在服务器磁盘上。拿到备份或磁盘的人只会读到毫无意义的字符。' },
      { silne: '消息会自己删除', text: '在设定的期限后（默认 90 天），语音留言和照片也一样。不在这里的东西就泄不出去。' },
      { silne: '你的过渡阶段是私密的', text: '除非你自己公开。你在指南里勾选的步骤，别人看不到。' },
      { silne: '邮箱和电话', text: '从不会展示给其他成员。' },
      { silne: '', text: '登录通过限制尝试次数来防止有人猜密码。' },
      { silne: '消息的端到端加密。', text: '开启后，文字和附件在你自己的浏览器里加密，服务器只收到一串乱码。密钥由你的密码解开，从不离开你的设备——所以内容我们也读不到，即使法院来要也一样。代价是：如果你忘了密码，你自己也读不了旧消息。' },
      { silne: '', text: '登录状态不会长期保留：关掉窗口时，以及十分钟没有操作后，Bloom 会把你登出。' },
    ],
  'auth.seznamNeumime': [
      { silne: '元数据', text: '——谁在什么时候写给谁——服务器必须知道，才能把消息送到。端到端加密藏不住这些，Signal 也一样。' },
      { silne: '', text: 'Bloom 是网页应用，所以每次打开都会从我们的服务器下载加密代码。理论上，控制了服务器的人可以送出被改过的代码。只有来自应用商店的签名应用才能防住这一点——这也是 Signal 有而网页版没有的。' },
      { silne: '个人资料', text: '——昵称、简介、头像——无法加密，因为服务器必须把它们展示给其他成员。' },
      { silne: '', text: '你开启加密之前的消息只在服务器磁盘上加密，不是端到端的。' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom 用起来像一个应用，离线也能用。你的数据始终是最新的。',
  'auth.zabezpeceniTitulek': 'Bloom 是怎么保护你的',
  'auth.zabezpeceniUvod': 'Bloom 是跨性别社群的空间，所以这里会碰到敏感的事。下面写的是我们为保护这些'
      + '所做的，以及我们做不到的——不加粉饰。',
  'auth.coJeChranene': '受保护的部分',
  'auth.coNeumime': 'Bloom 做不到的——把话说清楚才公平',
  'auth.zabezpeceniZaver': '如果你对隐私有疑问，或者发现了漏洞，请用下面的“报告问题”。我们会认真对待。',
  'auth.mvp': 'Bloom 还是第一个版本，我们和社群一起在改进它。'
      + '如果你碰到问题或有想法，我们很想听。',
  'auth.nahlasitProblem': '报告问题',
  'auth.clenu': () => '位成员',
  'auth.prispevku': () => '条帖子',
  'auth.odborniku': () => '位专业人士',
  'auth.nabidek': () => '条互助信息',

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': '昵称（唯一）',
  'reg.prezdivkaPriklad': '至少 3 个字符',
  'reg.telefon': '电话号码',
  'reg.volitelne': '（可填可不填）',
  'reg.heslo': '密码',
  'reg.hesloZnovu': '再输一次密码',
  'reg.zajmeno': '人称代词',
  'reg.oMne': '关于我',
  'reg.oMnePriklad': '写几句关于你自己的话…',
  'reg.registrovat': '创建账号',
  'reg.registruji': '正在创建账号…',
  'reg.presGoogle': '用 Google 注册',
  'reg.avatar': '头像',
  'reg.neboFoto': '或上传你自己的照片',
  'reg.nahratFoto': '上传照片',
  'reg.vlastni': '自定义',
  'reg.zeme': '国家',
  'reg.kraj': '地区',
  'reg.nechciUvadet': '不想说',
  'reg.cesko': '捷克',
  'reg.svet': '世界其他地方',

  // skupiny avatarů
  'reg.avatarFem': '偏女性',
  'reg.avatarMask': '偏男性',
  'reg.avatarNeutr': '中性',
  'reg.avatarZvirata': '动物',

  // komunitní heslo
  'reg.komunitniHeslo': '社群口令',
  'reg.komunitniHesloPriklad': '输入社群口令…',
  'reg.komunitniHesloPopis': 'Bloom 是跨性别社群的私密空间。社群里的人可以把口令给你。',
  'reg.napisAdminovi': '如果你谁都不认识，写信给管理员：',
  'reg.nevimHeslo': '我不知道社群口令',
  'reg.jakZiskat': '社群口令保护着这个私密空间。要怎么拿到：',
  'reg.krok1': '1. 写一封邮件到',
  'reg.krok2': '2. 简单介绍一下自己，说说你是怎么知道 Bloom 的',
  'reg.krok3': '3. 管理员会尽快回复',

  // kontrola hesla
  'reg.hesloKratke': '密码至少要 8 个字符',
  'reg.hesloMale': '密码里要有一个小写字母',
  'reg.hesloVelke': '密码里要有一个大写字母',
  'reg.hesloCislo': '密码里要有一个数字',
  'reg.hesloZnak': '密码里要有一个特殊符号（!@#$%…）',
  'reg.pozadavek8': '至少 8 个字符',
  'reg.pozadavekVelke': '大写字母',
  'reg.pozadavekCislo': '数字',
  'reg.pozadavekZnak': '特殊符号（!@#$%）',
  'reg.hesloNesouhlasi': '两次输入的密码不一样',
  'reg.prezdivkaKratka': '昵称至少要 3 个字符',
  'reg.hesloPovinne': '社群口令是必填的',
  'reg.hotovo': '账号已创建。请查看邮箱完成确认。',
  'reg.fotoVelka': '图片太大了（最多 2 MB）',
  'reg.chyba': '注册没有成功',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': '这里没有人非得完美。Bloom 是一个每个人都能做自己的空间——'
      + '你可以在这里分享经历、提问，也可以帮别人。不评判，不带偏见。',
  'domu.citatAutor': '—— Martina Sobková',
  'domu.prelozenoZCestiny': ' · 译自捷克语',
  'domu.vitej': '欢迎你，',
  'domu.vCislech': '数字里的 Bloom',
  'domu.noveVKomunite': '刚来这里？',
  'domu.noveVKomunitePopis1': '你不必被看见。你不需要照片。你也不必已经出柜。',
  'domu.noveVKomunitePopis2': 'Bloom 是一个你可以按自己节奏开始的空间。',
  'domu.rozcestnik1': '我是第一次来',
  'domu.rozcestnik2': '我不知道从哪里开始',
  'domu.rozcestnik3': '我想保持匿名',
  'domu.rozcestnik4': '我在找专业人士',
  'domu.rozcestnik5': '我只想看看别人的故事',
  'domu.otazky': '有问题，或想了解更多？写信给我们：',
  'domu.doporucujeme': '推荐',
  'domu.odbornici': '专业人士',
  'domu.noviClenove': '社群的新成员',
  'domu.zadniNovi': '还没有新成员',
  'domu.nejnovejsiOtazky': '最新的提问',
  'domu.zadneOtazky': '还没有提问。',
  'domu.nejlepeHodnoceni': '评价最高的专业人士',
  'domu.zadniHodnoceni': '还没有被评价过的专业人士',
  'domu.zadneAktuality': '还没有消息',

  // dlaždice sekcí
  'domu.dlazdice.support': '拿出你会的东西，也从别人那里得到帮助。',
  'domu.dlazdice.specialists': '找经过核实的专业人士，从心理师到整形外科医生。',
  'domu.dlazdice.legal': '法律帮助、文章，以及对你问题的解答。',
  'domu.dlazdice.nearby': '你附近的服务和专业人士。',

  // počty
  'domu.pocetClenu': () => '位社群成员',
  'domu.pocetZkusenosti': () => '个分享出来的故事',
  'domu.pocetOdborniku': () => '位经核实的专业人士',
  'domu.pocetNabidek': () => '条互助信息',

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': '首页',
  'nav.news': '动态',
  'nav.stories': '社群故事',
  'nav.mapaSveta': '世界地图',
  'nav.support': '互相帮助',
  'nav.specialists': '跨性别友善的专业人士',
  'nav.legal': '法律帮助',
  'nav.pageants': '选美比赛',
  'nav.nearby': '我附近',
  'nav.hledat': '在 Bloom 里搜索',
  'nav.hledatPlaceholder': '搜索人、专业人士、文章…',
  'nav.zpravy': '消息',
  'nav.profil': '我的资料',
  'nav.mojeCesta': '我的旅程',
  'nav.administrace': '管理',
  'nav.odhlasit': '登出',
  'nav.vsechnyVysledky': (p) => `显示“${p.dotaz}”的全部结果`,
  'nav.overEmail': '确认你的邮箱',
  'nav.menu': '菜单',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': '世界各地的 Bloom',
  'svet.podtitulek': '选一个国家，看看社群在那里攒下了什么。',
  'svet.hledatZemi': '搜索国家…',
  'svet.vsechnyZeme': '所有国家',
  'svet.jenSObsahem': '只看有内容的国家',
  'svet.nicNenalezeno': '没有匹配的国家。',
  'svet.zaznamu': (p) => `${p.pocet} 条记录`,
  'svet.prazdnaZeme': '还没有内容',
  'svet.kontinent': '大洲',
  'svet.celySvet': '整个世界',
  'svet.vse': '全部',
  'svet.zacniDomovem': '先选你称之为家的国家。你也可以从地图下面的列表里选。',
  'svet.zkoumej': '选一个国家，看看 Bloom 在那里有什么。你想逛哪里都行——'
      + '这不会改变你的家乡国家。',
  'svet.domov': '家乡',
  'svet.zrusitDomov': '清除家乡国家',
  'svet.nastavitDomov': '设为家乡国家',
  'svet.zeSveta': '来自世界各地',
  'svet.coSeChysta': '即将开始',
  'svet.souteze': '正在报名的选美比赛',
  'svet.noveOrganizace': '新的组织',
  'svet.kdeJizNeco': 'Bloom 已经有内容的地方',
  'svet.hledatZemiPopisek': '搜索国家',
  'svet.nicNeodpovida': '没有匹配的。换个词试试。',
  'svet.napovedaKMape': '拖动地图可以移动，用滚轮或按钮可以缩放。你不一定'
      + '要用它——搜索和完整的国家列表都在下面。',
  'svet.tvujBloom': (p) => `你在${p.zeme}的 Bloom`,
  'svet.tvojeDomovska': '你的家乡国家',
  'svet.zemi': (p) => `${p.pocet} 个国家`,
  'svet.chyba': '国家列表没能加载。请重新载入页面。',
  'svet.pocet.specialists': (p) => `${p.pocet} 位专业人士`,
  'svet.pocet.organizations': (p) => `${p.pocet} 个组织`,
  'svet.pocet.events': (p) => `${p.pocet} 个活动`,
  'svet.pocet.pageants': (p) => `${p.pocet} 场比赛`,
  'svet.pocet.resources': (p) => `${p.pocet} 条资料`,

  // světadíly
  'kontinent.europe': '欧洲',
  'kontinent.asia': '亚洲',
  'kontinent.africa': '非洲',
  'kontinent.north_america': '北美洲',
  'kontinent.south_america': '南美洲',
  'kontinent.oceania': '大洋洲',
  'kontinent.antarctica': '南极洲',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': '来自世界各地的跨性别选美比赛。还能报名的排在最上面。',
  'souteze.hledat': '搜索比赛…',
  'souteze.zadne': '我们这里还没有比赛。你知道哪一个吗？发个建议给我们。',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `打开${p.zeme}`,
  'nahled.zavrit': '关闭预览',
  'nahled.jenInformace': '目前我们只有关于这个国家的资料。',
  'nahled.zatimNic': '这里还没有联系人、组织或活动。你知道什么吗？发个建议给我们。',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `${p.zeme}的 Bloom`,
  'zeme.podtitulek': (p) => `社群在${p.zeme}攒下来的东西。`,
  'zeme.prazdna': 'Bloom 在这里才刚开始。你可以成为第一个添加内容的人。',
  'zeme.mapaSveta': '世界地图',
  'zeme.navrhnout': '推荐一条记录',
  'zeme.domovska': '你的家乡国家',
  'zeme.nastavitDomovskou': '设为家乡国家',
  'zeme.kdeToJe': '在哪里可以找到',
  'zeme.coTuBude': '这里会有什么',
  'zeme.zatimPrazdne': '目前还是空的',
  'zeme.pripravujeme': '正在准备',
  'zeme.zobrazitVse': (p) => `显示全部（${p.pocet}）`,
  'zeme.rosteTitulek': 'Bloom 在这里才刚长起来',
  'zeme.rostePopis': '这里我们还什么都没有。你知道哪个组织、活动或者'
      + '有用的联系人吗？发个建议给我们——经过审核后就会出现在这里。',
  'zeme.jinouZemi': '逛逛别的国家',
  'zeme.bezKontaktu': '这里我们还没有联系人或组织。',
  'zeme.bezKontaktuPopis': '你在这里认识什么人或知道什么有用的吗？发个建议给我们——'
      + '经过审核后就会出现在这里。',
  'zeme.neznama': '我们不认识这个国家。',
  'zeme.chyba': '这个国家没能加载。',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': '医生和诊所',
  'sekce.specialists.popis': '社群有过接触经验的医生、诊所和其他专业人士。',
  'sekce.organizations': '组织',
  'sekce.organizations.popis': '协会、非营利机构和互助小组。',
  'sekce.events': '活动',
  'sekce.events.popis': '聚会、骄傲游行、工作坊和会议。',
  'sekce.pageants': '选美比赛',
  'sekce.pageants.popis': '跨性别选美比赛和它们的日期。',
  'sekce.resources': '资料',
  'sekce.resources.popis': '这个国家的实用信息。',
  'sekce.community': '社群',
  'sekce.community.popis': '这个国家里的人和团体。',
  'sekce.legal': '法律帮助',
  'sekce.legal.popis': '给跨性别社群的信息和支持',
  'sekce.support': '互相帮助',
  'sekce.support.popis': '拿出你会的东西，也从其他社群成员那里得到帮助',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': '在这个国家里搜索…',
  'vypis.vsechnyKategorie': '所有分类',
  'vypis.kategorie': '分类',
  'vypis.celaZeme': '全国',
  'vypis.navrhnout': '推荐',
  'vypis.nicNeodpovida': '没有匹配的。换个词试试，或者清掉筛选。',
  'vypis.zadneZaznamy': (p) => `我们在${p.zeme}还没有记录。`,
  'vypis.zaznamu': (p) => `${p.pocet} 条记录`,
  'vypis.predchozi': '上一页',
  'vypis.dalsi': '下一页',
  'vypis.chyba': '记录没能加载。',
  'vypis.neznamyDruh': '我们不认识这种记录。',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `回到${p.zeme}`,
  'detail.kontakty': '联系方式和链接',
  'detail.podrobnosti': '详情',
  'detail.zacatek': '开始',
  'detail.termin': '日期',
  'detail.uzaverka': '报名截止',
  'detail.prihlaska': '报名',
  'detail.strankaAkce': '活动页面',
  'detail.web': '网站',
  'detail.konec': '结束',
  'detail.stavRocniku': '本届状态',
  'detail.oblasti': '工作领域',
  'detail.coNabizi': '他们提供什么',
  'detail.kategorie': '分类',
  'detail.jazyky': '语言',
  'detail.vitezove': '往届获胜者',
  'detail.kdoSeMuze': '谁可以参加',
  'detail.poradatel': '主办方',
  'detail.poplatek': '费用',
  'detail.tema': '主题',
  'detail.forma.offline': '线下',
  'detail.forma.online': '线上',
  'detail.forma.hybrid': '线下加线上',
  'detail.rozsah.local': '本地',
  'detail.rozsah.national': '全国',
  'detail.rozsah.international': '国际',
  'detail.rocnik.upcoming': '即将举行',
  'detail.rocnik.registration_open': '报名开放中',
  'detail.rocnik.registration_closed': '报名已关闭',
  'detail.rocnik.completed': '已结束',
  'detail.zdroj': (p) => `来源：${p.zdroj}`,
  'detail.upraveno': (p) => `最后更新：${p.datum}`,
  'detail.overeno': '已核实无误。这不代表 Bloom 为其背书。',
  'detail.neovereno': '这条记录还没有核实过。细节可能已经变了——请向来源确认。',
  'detail.nenalezen': '我们不认识这条记录。它可能已被删除，或者还在等待审核。',
  'detail.chyba': '这条记录没能加载。',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': '这里的规定',
  'profil.name_change': '改名',
  'profil.gender_marker': '法律性别标记',
  'profil.surgery_required': '是否要求手术',
  'profil.healthcare': '医疗服务的可及性',
  'profil.legal_protection': '反歧视保护',
  'profil.safety': '安全',
  'profil.stav.yes': '是',
  'profil.stav.limited': '部分',
  'profil.stav.no': '否',
  'profil.stav.unknown': '不清楚',
  'profil.zdroj': '来源',
  'profil.zdrojZRoku': (p) => `${p.rok} 年的来源`,
  'profil.overeno': (p) => `${p.datum} 核实`,
  'profil.zmena': '近期变化',
  'profil.odKdy': (p) => `自 ${p.datum} 起生效`,
  'profil.doklady': '依据',
  'profil.zakon': '法律或法院',
  'profil.upozorneni': '这不是法律意见。法律会变，很多事情也取决于你自己的'
      + '具体情况——在依据这些采取行动之前，请向来源或那个国家的'
      + '组织确认。',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `推荐${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': '你的推荐会先经过审核，然后才会出现在 Bloom 里。填你知道的'
      + '就好——剩下的我们来补。',
  'navrh.jednotne.organizations': '一个组织',
  'navrh.jednotne.events': '一个活动',
  'navrh.jednotne.pageants': '一场比赛',
  'navrh.jednotne.resources': '一条资料',
  'navrh.popis.organizations': '协会、非营利机构或互助小组。',
  'navrh.popis.events': '聚会、骄傲游行、工作坊、会议。',
  'navrh.popis.pageants': '跨性别选美比赛——日期、报名、主办方。',
  'navrh.popis.resources': '实用信息——医疗、法律、证件、联系方式。',
  'navrh.nazev': '名称',
  'navrh.popisPole': '描述',
  'navrh.zeme': '国家',
  'navrh.mesto': '城市',
  'navrh.adresa': '地址',
  'navrh.web': '网站',
  'navrh.email': '电子邮箱',
  'navrh.telefon': '电话',
  'navrh.odkudVis': '你是怎么知道的',
  'navrh.odkudVisPriklad': '例如：他们的网站、我去过…',
  'navrh.vyberte': '— 请选择 —',
  'navrh.forma': '形式',
  'navrh.rozsah': '范围',
  'navrh.platiPro': '适用于',
  'navrh.platnost.global': '全世界',
  'navrh.platnost.country': '一个国家',
  'navrh.platnost.region': '一个地区',
  'navrh.platnost.city': '一座城市',
  'navrh.odkazAkce': '活动链接',
  'navrh.odkazPrihlaska': '报名链接',
  'navrh.odkazy': '链接',
  'navrh.text': '正文',
  'navrh.odeslat': '发送推荐',
  'navrh.odesilam': '发送中…',
  'navrh.chyba': '推荐没能发出去',
  'navrh.dikyTitulek': '谢谢，我们收到了',
  'navrh.dikyPopis': '我们收到了你的推荐。会有人看过之后，它才会'
      + '出现在 Bloom 里。没有任何东西是自动发布的。',
  'navrh.zavrit': '关闭',
  'navrh.seznamNapoveda': '多个项目之间用逗号分开。',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `这个${p.druh}是你的吗？`,
  'prevzeti.popis': '你可以接管这个页面，把资料保持在最新状态。'
      + '申请会先经过审核。',
  'prevzeti.tlacitko': '认领这个页面',
  'prevzeti.spravujes': '这个页面由你管理。你随时可以修改资料——改动立刻生效。',
  'prevzeti.upravit': '修改资料',
  'prevzeti.spravujeSama': (p) => `这个页面由该${p.druh}自己管理。`,
  'prevzeti.ceka': '我们收到了你的认领申请，正在审核。',
  'prevzeti.formulacTitulek': (p) => `认领页面 — ${p.nazev}`,
  'prevzeti.formulacPopis': '在把页面交给你之前，我们需要确认你确实属于这个'
      + '组织。申请会经过审核；不会马上有任何改变。',
  'prevzeti.role': '你在那里担任什么角色？',
  'prevzeti.rolePriklad': '例如：协调员、协会主席',
  'prevzeti.doklad': '我们要怎么核实这一点？',
  'prevzeti.dokladPriklad': '例如：组织网站的联系人页面上有我；或者用官方邮箱来信',
  'prevzeti.dokladNapoveda': '一个能看到你名字的页面链接就够了，或者用组织的'
      + '官方邮箱来写信。',
  'prevzeti.kontakt': '你的联系方式',
  'prevzeti.kontaktPriklad': '邮箱或电话',
  'prevzeti.dalsi': '还有别的吗',
  'prevzeti.nepovinne': '（可填可不填）',
  'prevzeti.odeslat': '发送申请',
  'prevzeti.odesilam': '发送中…',
  'prevzeti.vyplnObe': '请告诉我们你的角色，以及要怎么核实。',
  'prevzeti.prijato': '谢谢。我们收到了你的申请，会回复你。',
  'prevzeti.chyba': '申请没能发出去。',
  'prevzeti.upravaTitulek': (p) => `修改页面 — ${p.nazev}`,
  'prevzeti.upravaPopis': '名称和地点故意没放在这里：记录是按它们来搜索和'
      + '排序的。如果它们变了，写信给我们，我们来更新。',
  'prevzeti.popisPole': '描述',
  'prevzeti.email': '电子邮箱',
  'prevzeti.telefon': '电话',
  'prevzeti.web': '网站',
  'prevzeti.ulozeno': '已保存。',
  'prevzeti.ukladam': '保存中…',
  'prevzeti.chybaUlozeni': '没能保存。',
  'prevzeti.druh.organizations': '组织',
  'prevzeti.druh.events': '活动',
  'prevzeti.druh.pageants': '比赛',
  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': '修改你的资料和设置',
  'profil.overeny': '已确认',
  'profil.neovereny': '未确认',
  'profil.overteEmail': '请确认你的邮箱。未确认的账号权限有限。',
  'profil.emailOdeslan': '确认邮件已发送。',
  'profil.emailChyba': '邮件没能发出去',
  'profil.odeslano': '已发送。',
  'profil.overeniOdbornika': '专业人士或律师的认证',
  'profil.pracujeteVOboru': '你在这个行业工作吗？拿一个认证标识。',
  'profil.zadostOdeslana': '申请已发送',
  'profil.pozadatOOvereni': '申请认证',
  'profil.zadostTitulek': '申请认证为专业人士或律师',
  'profil.zadostPopis': '填写你申请的细节。审核员会看。',
  'profil.pozadovanaRole': '申请的身份',
  'profil.roleOdbornik': '专业人士',
  'profil.rolePravnik': '律师',
  'profil.specializace': '专长',
  'profil.odkazNaProfil': '专业主页的链接',
  'profil.zpravaProAdmina': '给管理员的一段话',
  'profil.odesilam': '发送中…',
  'profil.odeslatZadost': '发送认证申请',
  'profil.vyplnteSpecializaci': '请填写你的专长',
  'profil.zadostUspech': '你的认证申请已经发送。',
  'profil.zadostChyba': '申请没能发出去',

  // bezpečnost
  'bezp.titulek': '安全',
  'bezp.sifrovaniZapnuto': (p) => `消息加密已开启${p.odemceno ? '，并且已解锁' : '（在这个标签页里是锁着的）'}。`,
  'bezp.sifrovaniVypnuto': '你还没有开启消息加密。',
  'bezp.sifrovaniKde': '在“消息”页面开启并解锁。',
  'bezp.sifrovaniKdeVypnute': '你可以在“消息”页面的任何一段对话里开启它。',
  'bezp.zmenaHesla': '修改密码',
  'bezp.zmenaHeslaSifrovani': '你开着加密，所以改密码的同时也会重新包装你的消息密钥。'
      + '这就是为什么需要现在的密码——没有它，密钥打不开，你的消息就没了。',
  'bezp.stavajiciHeslo': '当前密码',
  'bezp.noveHeslo': '新密码',
  'bezp.noveHesloZnovu': '再输一次新密码',
  'bezp.pozadavky': '至少 8 个字符，包含大小写字母、一个数字和一个特殊符号。',
  'bezp.zmenitHeslo': '修改密码',
  'bezp.menim': '修改中…',
  'bezp.hesloNeshoda': '两次输入的新密码不一样。',
  'bezp.vyplnObe': '请把两个密码都填上。',
  'bezp.stareNesedi': '当前密码不对——那样会丢掉你的消息密钥，所以什么都没有改。',
  'bezp.zmenenoSKlicem': '密码已修改。你的消息密钥被重新包装过，所以旧消息仍然读得到。',
  'bezp.zmeneno': '密码已修改。',
  'bezp.zmenaChyba': '密码没能修改。',
  'bezp.nepamatujes': '不记得密钥的密码了？',
  'bezp.zahoditPopis': '你可以丢掉密钥，重新开始。到目前为止加密过的消息会永远消失'
      + '——没有人能读到，我们也不能。正因为如此，这才是安全的。',
  'bezp.zahodit': '丢掉密钥，重新开始',
  'bezp.zahoditPotvrzeni': '真的要丢掉密钥吗？\n\n到目前为止加密过的每一条消息都会永远消失'
      + '——没有人能读到，我们也不能。只有在你不记得开启加密时用的那个密码时，'
      + '才这么做。',
  'bezp.klicSmazan': '密钥已删除。请重新载入页面。',
  'bezp.nepovedlo': '这次没成功。',
  'bezp.prohlizecNeumi': '这个浏览器不支持 Bloom 用的加密方式。',

  'profil.mujProfil': '我的资料',
  'profil.specializacePriklad': '例如：心理师、性学医生、律师…',
  'profil.zpravaPriklad': '比如你的执业注册或诊所网站的链接…',
  'profil.overeniUvod': '你想在 Bloom 上成为经过认证的专业人士或律师吗？发一份认证申请。'
      + '你的资料要和你真实的职业相符。',

  'profil.oborPriklad': '例如：整形外科、家庭法…',
  'profil.nepovinnyText': '可填可不填的补充说明…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': '两步登录',
  'dvf.zapnuto': (p) => `已开启。你还剩 ${p.pocet} 个备用码。`,
  'dvf.vypnuto': '除了密码，你还要输入手机应用上显示的六位数字。',
  'dvf.chraniA': '它保护的是',
  'dvf.chraniPrihlaseni': '登录本身',
  'dvf.chraniB': '：知道你密码但没有你手机的人，进不来。',
  'dvf.nechrani': '它保护不了加密消息',
  'dvf.nechraniPopis': '——那些是用你的密码在你自己的浏览器里解开的，跟服务器无关。',
  'dvf.ulozKody': '把这十个备用码存好',
  'dvf.ulozKodyPopis1': '每个只能用一次，而且手机丢了的话，它们是唯一的进路。',
  'dvf.znovuNeukaze': '没有人会再给你看第二次',
  'dvf.ulozKodyPopis2': '——我们只保存它们的摘要。',
  'dvf.zkopirovat': '复制',
  'dvf.ulozilaJsem': '我已经存好了',
  'dvf.zkopirovano': '已复制。',
  'dvf.kopieChyba': '复制失败，请手抄一下。',
  'dvf.zapnout': '开启两步登录',
  'dvf.pripravuji': '准备中…',
  'dvf.nactiKod': '用验证器应用扫描这个码——例如 Google Authenticator、Authy、1Password 或 Aegis。',
  'dvf.qrNejde': '扫不了二维码？',
  'dvf.zadejRucne': '在应用里手动输入这个密钥：',
  'dvf.opisKod': '输入应用里显示的验证码',
  'dvf.zapnoutKratce': '开启',
  'dvf.overuji': '检查中…',
  'dvf.noveKody': '新的备用码',
  'dvf.vypnout': '关闭',
  'dvf.noveKodyPopis': '新的一组会替换掉旧的——你现在的备用码会失效。',
  'dvf.kodZAplikace': '应用里的验证码',
  'dvf.vygenerovat': '生成',
  'dvf.vypnutiPopis': '关闭它需要你的密码和一个有效的验证码。两样都是故意的：否则，任何能碰到已解锁浏览器的人都能把它摘掉。',
  'dvf.kodNeboZalozni': '应用里的验证码或备用码',
  'dvf.vypinam': '关闭中…',
  'dvf.vypnoutCele': '关闭两步登录',
  'dvf.vypnuto2': '两步登录已关闭。',
  'dvf.kodNesedi': '这个验证码不对。',
  'dvf.nepovedlo': '这次没成功。',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': '资料已更新。',
  'pf.chyba': '资料没能更新',
  'pf.fotkaNahrana': '照片已上传。',
  'pf.fotkaChyba': '图片没能上传',
  'pf.fotkaVelka': '图片太大了（最多 5 MB）',
  'pf.oznameniUlozeno': '通知设置已保存。',
  'pf.oznameniChyba': '设置没能保存',
  'pf.zruseno': '你的资料已经删除',
  'pf.zruseniChyba': '资料没能删除',
  'pf.zruseniPotvrzeni': '你真的要删除你的资料吗？这没法撤销，你所有的数据都会被清掉。',
  'pf.urlFacebook': 'Facebook 地址要以 https:// 开头',
  'pf.urlInstagram': 'Instagram 地址要以 https:// 开头',
  'pf.urlLinkedin': 'LinkedIn 地址要以 https:// 开头',
  'pf.ukladam': '保存中…',
  'pf.ulozitOznameni': '保存通知设置',
  'pf.oznameniZpravy': '私信',
  'pf.oznameniAdmin': '管理员发来的新消息',
  'pf.oznameniUzivatel': '其他成员发来的新消息',
  'pf.oznameniPodpora': '“互相帮助”里的新帖子',
  'pf.oznameniNabidky': '互助信息和请求',

  // odznaky
  'pf.odznakAdmin': '管理员',
  'pf.odznakPravnik': '律师',
  'pf.odznakSpecialista': '经核实的专业人士',
  'pf.odznakClen': '经核实的社群成员',
  'pf.odznakPomocnik': '活跃的帮助者',
  'pf.odznakDuveryhodny': '值得信赖的成员',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': '照片已加入相册。',
  'gal.smazano': '照片已删除',
  'gal.hesloKratke': '相册密码至少要 4 个字符',
  'gal.nahraniChyba': '照片没能上传',
  'gal.mazaniChyba': '照片没能删除',
  'gal.souborVelky': '文件太大了（最多 5 MB）',
  'gal.ulozitNastaveni': '保存设置',
  'gal.soukromiGalerie': '相册的隐私',
  'gal.verejnaGalerie': '公开相册',
  'gal.hesloPopis': '访客要输入这个密码才能看到相册。',
  'gal.pridat': '添加照片或视频',
  'gal.prazdna': '相册里还没有照片',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': '我现在在哪一步？',
  'cesta.popis': '愿意的话可以分享你的过渡阶段——也可以只留给自己。',
  'cesta.soukroma': '你的阶段是私密的',
  'cesta.viditelna': '别人能看到你的阶段',
  'cesta.jenTy': '只有你自己看得到你的阶段',
  'cesta.mohouNajit': '别人可以通过“找处在相似阶段的人”找到你',
  'cesta.poznamka': '私人笔记',
  'cesta.volitelna': '（可填可不填）',
  'cesta.poznamkaPriklad': '任何你想分享或记下来的事…',
  'cesta.najitPodobne': '找处在相似阶段的人',
  'cesta.hledam': '搜索中…',
  'cesta.ulozit': '保存我的旅程',
  'cesta.ulozeno': '你的旅程已保存。',
  'cesta.vyberteFazi': '请选一个阶段',
  'cesta.chyba': '没能保存',

  'pf.socialniSite': '社交网络',
  'pf.avatarFoto': '头像 / 个人照片',
  'pf.nahratProfilni': '上传头像照片',
  'pf.zrusitProfil': '删除资料',
  'pf.nastaveniOznameni': '通知设置',
  'pf.nastaveniOznameniPopis': '选择你想收到哪些事情的通知。',
  'gal.overEmail': '要上传照片，请先确认你的邮箱。',
  'cesta.coMeCeka': '前面有什么',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': '消息',
  'zpr.hledatUzivatele': '搜索成员…',
  'zpr.zadneKonverzace': '还没有对话',
  'zpr.vyhledejteVyse': '在上面搜索成员',
  'zpr.vyberteKonverzaci': '选一段对话，或者搜索一位成员',
  'zpr.napisteZpravu': '写点什么…',
  'zpr.nahravam': '录音中…',
  'zpr.prilozitObrazek': '附上图片',
  'zpr.hlasovaZprava': '语音消息',
  'zpr.zastavitNahravani': '停止录音',
  'zpr.obrazek': '图片',
  'zpr.overteEmail': '要发送消息，请先确认你的邮箱。',
  'zpr.profil': '资料',

  // šifrování
  'zpr.sifrovanaZprava': '加密的消息',
  'zpr.odemkniNahore': '加密的消息——请在上面解锁你的消息。',
  'zpr.nelzeOtevrit': '这条加密消息打不开。',

  // hlášky
  'zpr.uzivatelNenalezen': '找不到这个人',
  'zpr.prijemceNenalezen': '找不到收信人',
  'zpr.prihlasteZnovu': '请重新登录（你的会话已过期）',
  'zpr.serverNedostupny': '连不上服务器。检查一下后端是不是在运行。',
  'zpr.chybaOdeslani': '没能发出去',
  'zpr.souborVelky': '文件太大了（最多 5 MB）',
  'zpr.formatNepodporovan': '不支持这种文件类型',
  'zpr.mediaOdeslano': '文件已发送',
  'zpr.mikrofon': '麦克风用不了',
  'zpr.hlasovkaOdeslana': '语音消息已发送',
  'zpr.hlasovkaChyba': (p) => `语音消息没能发出去：${p.detail}`,
  'zpr.smazano': '对话已删除',
  'zpr.smazaniChyba': '对话没能删除',
  'zpr.smazaniPotvrzeni': '它会从你的列表里消失，附件也一样。对方那边仍然留着一份——'
      + '只有你们两边都删掉，消息才会真正从服务器上消失。',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': '请输入你的密码。',
  'sif.zapnuto': '加密已开启。',
  'sif.odemceno': '你的消息已解锁。',
  'sif.hesloNesedi': '这个密码不对。',
  'sif.prohlizecNeumi': '这个浏览器不支持 Bloom 用的加密方式。你还是可以写消息，'
      + '但它们不会是端到端加密的。',
  'sif.noveJsouSifrovane': '新消息是加密的。只有你有密钥——服务器读不到。',
  'sif.odemkniZpravy': '解锁你的消息',
  'sif.odemkniPopis': '密钥只活在这个标签页的内存里，所以页面重新载入后还要再输一次密码。'
      + '我们没法把它存在任何地方——存了，它就不再是只有你能掌控的加密了。',
  'sif.zapniSifrovani': '开启消息加密',
  'sif.zapniPopis': '新消息就在你的设备上加密。服务器只收到一串乱码，'
      + '读不到内容——即使法院来要也一样。',
  'sif.pozorA': '注意：密钥是用你的密码解开的。',
  'sif.pozorTucne': '一旦你忘了它，没有人能读你的加密消息',
  'sif.pozorB': '——我们也不能。这正是重点所在，但也意味着你得把它记在某个地方。',
  'sif.mobilA': '开启它也会改变你登录的方式：你的密码完全不再到达服务器，只发送它的摘要。',
  'sif.mobilTucne': '旧版的 Bloom 手机应用将无法登录这个账号',
  'sif.mobilB': '，直到我们更新它为止。网页版上一切照常。',
  'sif.zapnoutSifrovani': '开启加密',
  'sif.odemknout': '解锁',
  'sif.tvojeHeslo': '你的 Bloom 密码',
  'sif.prilohaZamcena': '加密的附件——请在上面解锁你的消息。',
  'sif.prilohaChyba': '附件打不开。',
  'sif.priloha': '消息附件',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': '你的位置',
  'okoli.nastavtePolohu': '设定你的位置，结果才会贴合你',
  'okoli.vyberteVyse': '在上面选一个地点，就能看到你附近的互助信息和专业人士',
  'okoli.zadniOdbornici': '这个地区还没有登记的专业人士',
  'okoli.zadneNabidky': '这个地区还没有互助信息',
  'okoli.zadniClenove': '这个地区还没有社群成员',
  'okoli.vytvoritNabidku': '发一条互助信息',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': '正在搜索：',
  'hled.vysledkyPro': '搜索结果：',
  'hled.nicPro': '我们没有找到：',
  'hled.nicZkuste': '我们什么也没找到。换个词试试。',
  'hled.zkratte': '试试更短的说法，或者换个关键词。',
  'hled.zadejte': '输入你要找的东西，然后按回车',
  'hled.priklady': '例如：FFS、激素、改名、医生、证件、手术…',
  'hled.uzivatele': '成员',
  'hled.odbornici': '跨性别友善的专业人士',
  'hled.clanky': '法律帮助 – 文章',
  'hled.otazky': '社群提问',
  'hled.nabidky': '互助信息',
  'hled.prispevky': '帖子',
  'hled.recenze': '对专业人士的评价',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': '找不到这个人',
  'up.oMne': '关于',
  'up.clenOd': '加入时间',
  'up.odznakSpravce': '管理员',
  'up.odznakPravnik': '律师',
  'up.odznakOdbornik': '经核实的专业人士',
  'up.odznakPravnikOvereny': '经核实的律师',
  'up.odznakClen': '经核实的成员',
  'up.odznakPomocnik': '活跃的帮助者',
  'up.odznakDuveryhodny': '值得信赖',
  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': '回到 Bloom',
  'kom.oProjektu': 'Bloom 是为捷克的跨性别者建立的安全社群空间——一个可以'
      + '分享经历、寻找支持、联系专业人士、认识彼此的地方。'
      + '这个项目由社群志愿运作。它的目标是：谨慎、隐私和互相帮助。',
  'kom.kontaktText': '有问题，或者需要帮助？尽管联系我们。我们会尽快回复。',
  'kom.respekt': '我们彼此尊重',
  'kom.respektPopis': '我们用每个人自己使用的名字和人称代词来称呼对方。我们尊重不同的路径和经历'
      + '——做跨性别者没有对错之分。',
  'kom.soukromi': '我们守护彼此的隐私',
  'kom.soukromiPopis': '在 Bloom 里分享的，就留在 Bloom 里。未经同意，不要把别人的信息'
      + '说出去。我们尊重匿名。',
  'kom.pomahame': '我们互相帮助',
  'kom.pomahamePopis': 'Bloom 讲的是互相支持。我们分享经历、彼此帮忙，为每一个寻找连接或信息的人'
      + '搭一个安全的地方。',
  'kom.obtezovani': '我们不容忍骚扰',
  'kom.obtezovaniPopis': '骚扰、欺凌或带敌意的言论，在 Bloom 里没有位置。如果你觉得不舒服，'
      + '写信给管理员。',
  'kom.spam': '不要垃圾信息和广告',
  'kom.spamPopis': 'Bloom 不是市场。不要发未经邀请的广告或商业内容。'
      + '互助信息和请求属于“互相帮助”。',
  'kom.prostor': '每个阶段都有位置',
  'kom.prostorPopis': '不管你走到旅程的哪一步，你都不是一个人。我们欢迎正在考虑'
      + '过渡的人、正在过渡中的人，和已经走过来的人——每条路我们都照它本来的样子接受。',
  'kom.dataPopis': 'Bloom 只收集平台运转所必需的数据：你的邮箱、昵称，以及你自己创建的'
      + '个人资料。',
  'kom.dataTretiStrany': '你的数据不会分享给第三方。平台不使用任何追踪技术，也没有广告网络。',
  'kom.dataSmazani': '你有权要求删除你的账号和与之相关的所有数据。请联系管理员。',

  'okoli.podtitulek': '找到你附近的社群成员、服务和专业人士',
  'okoli.cleneVOkoli': (p) => `${p.misto}附近的社群成员`,
  'okoli.nabidkyVOkoli': (p) => `${p.misto}附近的互助信息`,
  'okoli.odborniciVOkoli': (p) => `${p.misto}附近的专业人士`,
  'hled.zobrazitVice': '显示更多',
  'kom.titulek': '社群守则',
  'kom.podtitulek': '一个属于所有人的安全空间',
  'kom.jakNahlasit': '怎么举报问题',
  'kom.jakNahlasitPopis': '如果你遇到不合适的行为，有两个办法：用对方资料页上的“举报这个人”'
      + '按钮，或者写信给管理员。',
  'kom.duverne': '你的举报是保密的。',
  'kom.ochranaSoukromi': '隐私',
  'obecne.zpetKratce': '返回',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': '社群里还没有别人公开分享这个阶段。',
  'cesta.poznamkaFazePriklad': '关于这个阶段，任何你想分享或记下来的事…',
  'pruvodce.fazeNenalezena': '找不到这个阶段',
  'pruvodce.pripravujeme': '这一部分我们还在准备。',
  'pruvodce.krokyJenTy': '你勾选的步骤只有你自己看得到。',
  'pruvodce.nastavitFazi': '设为我现在的阶段',
  'pruvodce.fazeNastavena': '已设为你现在的阶段',
  'pruvodce.chyba': '没能保存，请再试一次',
  'pruvodce.kroku': '个步骤',
  'pruvodce.odborniku': () => '位适合这个阶段的专业人士',
  'pruvodce.pribehu': () => '个来自这个阶段的人的故事',

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': '重置密码',
  'reset.popis': '为你的 Bloom 账号设一个新密码。',
  'reset.noveHeslo': '新密码',
  'reset.noveHesloPriklad': '输入新密码',
  'reset.potvrdit': '确认新密码',
  'reset.nastavit': '设定新密码',
  'reset.ukladam': '保存中…',
  'reset.hotovo': '你的密码已经改好了。现在可以登录了。',
  'reset.neplatnyOdkaz': '这个重置密码的链接无效。',
  'reset.odkazVyprsel': '重置链接已过期或无效。请重新申请一个。',
  'reset.chyba': '密码没能重置。',
  'reset.neshoda': '两次输入的密码不一样。',
  'reset.ztratiPristup': '将失去访问权',

  'cesta.volitelne': '这完全是自愿的。愿意的话可以分享你的过渡阶段——也可以只留给自己。'
      + '你也可以找到处在旅程相似位置的人。',
  'cesta.hledatVeFazi': '找处在这个阶段的人：',
  'cesta.jenVerejne': '（只包括公开分享的成员）',
  'pruvodce.zpetNaCestu': '回到“我的旅程”',
  'pruvodce.tadyJsi': '你现在在这里',
  'reset.prejitNaPrihlaseni': '去登录页',
  'reset.sifrovaniVarovani': '如果你开着消息加密：重置密码意味着你将再也读不到你以前的'
      + '加密消息。它们的密钥是用原来的密码解开的，而这里没有人知道那个密码，所以'
      + '没法重新包装。新消息仍然可以加密；旧的读不了了——我们也读不了。',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': '登录',
  'uvod.vytvoritUcet': '创建账号',
  'uvod.uzMamUcet': '我已经有账号了',
  'uvod.nadpis': '为跨性别社群准备的安全空间',
  'uvod.podnadpis': 'Bloom 是一个私密的地方，你可以在这里坦白地说话、找到跨性别友善的专业人士，'
      + '在懂得这种感受的人中间走过你的过渡。',
  'uvod.zdarma': '注册是免费的。Bloom 的内容要登录之后才会打开。',
  'uvod.kCemuJe': 'Bloom 是做什么的',
  'uvod.kCemuJe1': '在捷克找关于过渡的信息，通常意味着在散落各处的论坛、'
      + '过时的文章和不知道该不该信的链接之间点来点去。而且很多问题，'
      + '最好还是由亲身走过的人来回答。',
  'uvod.kCemuJe2': 'Bloom 把这些都放到一个地方：社群评价良好的专业人士、一份走过'
      + '过渡各个阶段的指南、法律帮助，以及最重要的——你可以写信的人。',
  'uvod.kCemuJe3': '而且因为这些是没有人想告诉整个互联网的事，Bloom 从一开始就是这样'
      + '造出来的：从外面看，什么都看不到。',
  'uvod.coNajdes': '你会在 Bloom 里找到什么',
  'uvod.coNajdesPopis': '八个彼此衔接的部分——从实用的帮助到分享的经历。',
  'uvod.soukromiZaklad': '隐私不是附加功能，而是地基',
  'uvod.jakZabezpeceny': 'Bloom 是怎么保护你的',
  'uvod.zabezpeceniPopis': '成员的数据从不出售，也不拿去分析。Bloom 上没有广告或分析的追踪'
      + '——没有任何第三方脚本知道关于你的任何事。',
  'uvod.coNeumi': 'Bloom 做不到的事',
  'uvod.metadataTucne': '谁在什么时候写给谁',
  'uvod.coNeumiA': '服务器始终知道',
  'uvod.coNeumiB': '——没有这些，它就没法把消息送到。端到端加密藏不住这些'
      + '元数据，Signal 也一样。个人资料没法加密，因为服务器必须把它们'
      + '展示给别人。而且因为 Bloom 是网页应用，每次打开都会从我们的服务器'
      + '下载加密代码——理论上，控制了服务器的人可以送出被改过的版本。'
      + '只有来自应用商店的签名应用才能防住这一点。',
  'uvod.pridejSe': '加入我们',
  'uvod.pridejSePopis': '一个昵称和一个邮箱就够了——你永远不必写出你的法定姓名。你写什么'
      + '关于自己的东西由你决定，而且随时可以改或删掉。',

  // co Bloom nabízí
  'uvod.karta.podpora': '提供帮助，或者开口求助——从陪着去看医生、借衣服，到'
      + '“我需要有人说说话”。',
  'uvod.karta.odbornici': '性学医生、内分泌医生、外科医生、心理治疗师，还有理发店。附带地图、联系方式和别人的经历。',
  'uvod.karta.pravo': '改名、官方证件、工作、学校。由熟悉门路的人来解答。',
  'uvod.karta.pruvodce': '每一步都包含什么——从最初的疑问到手术。附有经过核实的来源和专业人士的链接。',
  'uvod.karta.zpravy': '给社群里的任何人写信。消息和附件在服务器上是加密保存的。',
  'uvod.karta.zkusenosti': '来自亲身走过的人的真实故事。不删改，也不美化。',
  'uvod.karta.aktuality': '捷克跨性别议题上正在发生的事——法律变动、活动、社群消息。',
  'uvod.karta.okoli': '你附近有谁。让你知道自己并不孤单，哪怕在小城市里。',

  // zabezpečení
  'uvod.bezp.zvencinic': '从外面什么都看不到',
  'uvod.bezp.zvencinicText': '个人资料、故事、照片、互助信息和帖子里的图片，全都需要登录。没有账号，'
      + '服务器不会交出任何关于成员的信息——连搜索引擎也拿不到。',
  'uvod.bezp.hesla': '没人知道你的密码',
  'uvod.bezp.heslaText': '保存的只是 bcrypt 摘要，从它算不回原始密码。就连'
      + '管理员也看不到你的密码，也没法把它发给你——她只能让你重设一个新的。',
  'uvod.bezp.sifrovani': '从你到对方，消息是加密的',
  'uvod.bezp.sifrovaniText': '开启端到端加密后，文字和附件在你自己的浏览器里加密。'
      + '密钥由你的密码解开，从不离开你的设备——服务器只收到'
      + '一串乱码，读不到内容，即使法院来要也一样。不开加密的话，消息至少'
      + '在服务器磁盘上是加密的。',
  'uvod.bezp.kontakty': '你的联系方式仍然是你的',
  'uvod.bezp.kontaktyText': '你的邮箱和电话从不会给其他成员。你的过渡阶段是私密的，直到'
      + '你自己公开为止——你在指南里勾选的步骤也只有你自己看得到。',
  'uvod.bezp.smazane': '删掉就是真的删掉',
  'uvod.bezp.smazaneText': '你随时可以删掉一段对话。两边都删掉之后，它就永远从服务器上消失，'
      + '附件也一样。',
  'uvod.bezp.server': '在欧洲的自有服务器',
  'uvod.bezp.serverText': 'Bloom 跑在欧盟境内自己的服务器上，只走 HTTPS。数据库'
      + '从互联网上够不着。备份加密后送到另一处存储，恢复也测试过。',

  'uvod.karta.pruvodceNazev': '过渡指南',
  'uvod.karta.zpravyNazev': '私信',
  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': '拿出你会的东西，也从其他社群成员那里得到帮助',
  'pod.vse': '全部',
  'pod.nabidky': '我能提供',
  'pod.poptavky': '我在找',
  'pod.nabidka': '提供',
  'pod.poptavka': '寻找',
  'pod.celaCR': '捷克全境',
  'pod.celySvet': '全世界',
  'pod.cesko': '捷克',
  'pod.svet': '世界',
  'pod.vsechnyTypy': '所有分类',
  'pod.moje': (p) => `我的（${p.pocet}）`,
  'pod.pridat': '添加',
  'pod.overEmail': '确认你的邮箱才能发布',
  'pod.novaPoptavka': '新的寻找',
  'pod.novaNabidka': '新的提供',
  'pod.popisPoptavky': '写下你在找什么，以及你能拿什么来交换。',
  'pod.popisNabidky': '把你会的东西提供给其他社群成员。',
  'pod.typPrispevku': '帖子类型',
  'pod.volitelne': '（可填可不填）',
  'pod.coNabizim': '我能提供',
  'pod.coNabizimP': '我能提供 *',
  'pod.coHledamP': '我在找 *',
  'pod.coHledamVymenou': '我想换到什么',
  'pod.priklOffer': '例如：做饭、剪头发、翻译…',
  'pod.priklNeed': '例如：按摩、拍照…',
  'pod.poptavkaSeZobrazi': '你的寻找会出现在“我在找”这一栏。',
  'pod.nabidkaSeZobrazi': '如果你填了这一项，你的提供也会出现在“我在找”这一栏。',
  'pod.popis': '描述',
  'pod.popisPriklad': '更详细的描述…',
  'pod.oblast': '区域',
  'pod.lokalita': '地点',
  'pod.nechciUvadet': '不想说',
  'pod.kategorie': '分类',
  'pod.ostatni': '其他',
  'pod.pridatPoptavku': '发布寻找',
  'pod.pridatNabidku': '发布提供',
  'pod.odpovedetNaPrispevek': '回复帖子',
  'pod.napisteAutorovi': '给发帖的人写一封私信。',
  'pod.od': (p) => `来自：${p.kdo}`,
  'pod.odeslatZpravu': '发送消息',
  'pod.konceptOdpovedi': (p) => `你好！我对你的${p.co}“${p.nazev}”有兴趣。`,
  'pod.konceptPoptavka': '寻找',
  'pod.konceptNabidka': '提供',
  'pod.zadneMoje': '你还没有发过帖子',
  'pod.zadneNalezeny': '没有找到帖子',
  'pod.vytvortePrvni': '发布你的第一条提供或寻找',
  'pod.zkusteFiltry': '试试换个筛选，或者发一条新的',
  'pod.expirovano': '已过期',
  'pod.hledam': '我在找',
  'pod.hledamCo': (p) => `我在找：${p.co}`,
  'pod.nabizimCo': (p) => `我能提供：${p.co}`,
  'pod.expirovala': '这条已经过期了。想续期请联系管理员。',
  'pod.odpovedet': '回复',
  'pod.upravitPrispevek': '修改帖子',
  'pod.upravtePrispevek': '修改你的提供或寻找。',
  'pod.nabizimP': '我能提供 *',
  'pod.hledamPotrebuji': '我在找 / 我需要',
  'pod.coNabizitePriklad': '你能提供什么…',
  'pod.coHledatePriklad': '你在找什么…',
  'pod.ulozitZmeny': '保存修改',
  'pod.vytvorenoPoptavka': '寻找已发布。',
  'pod.vytvorenoNabidka': '提供已发布。',
  'pod.chybaVytvorit': '帖子没能创建',
  'pod.opravduSmazat': '要删掉这一条吗？',
  'pod.smazano': '已删除',
  'pod.chybaSmazat': '没能删除',
  'pod.aktualizovano': '帖子已更新。',
  'pod.chybaUlozit': '没能保存',
  'pod.zpravaOdeslana': '消息已发送。',
  'pod.chybaOdeslat': '消息没能发出去',
  'obecne.hledatPriklad': '搜索…',
  'obecne.upravit': '修改',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': '找到能在你这条路上帮你的、经过核实的专业人士',
  'odb.hledatPriklad': '按名字或城市搜索…',
  'odb.vsechnyObory': '所有领域',
  'odb.radit': '排序：',
  'odb.vychozi': '默认',
  'odb.nejvyssiHodnoceni': '★ 评分最高',
  'odb.nejnizsiHodnoceni': '★ 评分最低',
  'odb.zadniNalezeni': '没有找到专业人士',
  'odb.zkusteFiltry': '试试换个筛选',
  'odb.recenzi': () => '条评价',
  'odb.dostupnyV': '可提供服务的地方：',
  'odb.otevritVMapach': '在地图里打开',
  'odb.pridatRecenzi': '写一条评价',
  'odb.ohodnotte': '给你和这位专业人士打交道的经历打个分。',
  'odb.vaseHodnoceni': '你的评分 *',
  'odb.popisZkusenosti': '说说你的经历',
  'odb.popisteZkusenost': '说说你的经历…',
  'odb.odeslatRecenzi': '发送评价',
  'odb.recenze': (p) => `评价（${p.pocet}）`,
  'odb.zadneRecenze': '还没有评价。来做第一个。',
  'odb.vyberteOdbornika': '选一位专业人士，看看详情和地图',
  'odb.pridatOdbornika': '添加专业人士',
  'odb.pridejteOdbornika': '把一位新的、经过核实的专业人士加到列表里。',
  'odb.navrhnout': '推荐一位专业人士',
  'odb.navrhnetePopis': '推荐一位专业人士，交给管理员审核。',
  'odb.navrhVysvetleni': '你的推荐会发给管理员。通过之后，它就会出现在列表里。',
  'odb.overEmail': '确认你的邮箱才能推荐专业人士',
  'odb.jmeno': '名字 *',
  'odb.kategorie': '分类 *',
  'odb.popis': '描述',
  'odb.popisPriklad': '专长、经验…',
  'odb.adresa': '地址 *',
  'odb.mesto': '城市 *',
  'odb.kraj': '地区',
  'odb.vyber': '请选择',
  'odb.stat': '国家',
  'odb.cesko': '捷克',
  'odb.telefon': '电话',
  'odb.web': '网站',
  'odb.odesilam': '发送中…',
  'odb.odeslatKeSchvaleni': '提交审核',
  'odb.recenzePridana': '评价已添加。',
  'odb.chybaRecenze': '评价没能添加',
  'odb.odeslanKeSchvaleni': '这位专业人士已提交审核。',
  'odb.chybaOdeslat': '没能提交',
  'odb.pridan': '专业人士已添加。',
  'odb.chybaPridat': '没能添加',
  'odb.polozitOtazku': '提个问题',
  'odb.novaOtazka': '向专业人士提新问题',
  'odb.naCoSeZeptat': '你想问专业人士什么？',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': '给跨性别社群的信息和支持',
  'prav.zpetNaPoradnu': '回到“法律帮助”',
  'prav.clankyAPruvodci': '文章和指南',
  'prav.pridatClanek': '添加文章',
  'prav.novyClanek': '新文章',
  'prav.vytvorteClanek': '为法律板块写一篇新文章。',
  'prav.nazev': '标题 *',
  'prav.kategorie': '分类',
  'prav.publikovatIhned': '立即发布',
  'prav.publikovano': '已发布',
  'prav.obsah': '正文 *',
  'prav.obsahPriklad': '文章正文…',
  'prav.zadneClanky': '这个分类里还没有文章',
  'prav.skryto': '已隐藏',
  'prav.skryt': '隐藏',
  'prav.publikovat': '发布',
  'prav.upravitClanek': '修改文章',
  'prav.upravteObsah': '修改这篇文章的内容。',
  'prav.clanekPridan': '文章已添加。',
  'prav.chybaPridat': '文章没能添加',
  'prav.clanekUpraven': '文章已更新。',
  'prav.opravduSmazat': '要删掉这篇文章吗？',
  'prav.chybaStav': '状态没能修改',
  'prav.pridatOtazku': '添加提问',
  'prav.novaOtazka': '新的提问',
  'prav.naCoSeZeptat': '你想问什么？',
  'obecne.vse': '全部',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': '来自跨性别世界的消息',
  'akt.prehratVideo': '播放视频',
  'akt.obrazekVClanku': '文章里的图片',
  'akt.clanekNenalezen': '找不到这篇文章',
  'akt.zpetNaAktuality': '回到动态',
  'akt.autor': (p) => `作者：${p.kdo}`,
  'akt.osobniPribeh': '个人故事',
  'akt.upravitClanek': '修改文章',
  'akt.komentare': (p) => `评论（${p.pocet}）`,
  'akt.zadneKomentare': '还没有评论。来做第一个。',
  'akt.pridatKomentar': '写点什么…',
  'akt.proKomentovaniOverte': '确认你的邮箱才能评论。',
  'akt.profil': '资料',
  'akt.prihlasteSeProKomentovani': '登录后才能评论。',
  'akt.upravteObsah': '修改这篇文章的内容。',
  'akt.nadpisP': '标题 *',
  'akt.nadpis': '标题',
  'akt.obsahP': '正文 *',
  'akt.textClanku': '文章正文…',
  'akt.obrazekUrlNeboSoubor': '图片（网址或文件）',
  'akt.videoUrlNeboSoubor': '视频（网址或文件）',
  'akt.ukladam': '保存中…',
  'akt.novaAktualita': '新文章',
  'akt.sdiletPribeh': '分享一个故事',
  'akt.vytvoritAktualitu': '写一篇文章',
  'akt.sdiletZkusenost': '分享经历',
  'akt.napisteAktualitu': '给社群写一篇新文章。',
  'akt.podelteSe': '把你的经历分享给社群。',
  'akt.obrazek': '图片',
  'akt.nahratObrazek': '上传图片…',
  'akt.nahratVideo': '上传视频…',
  'akt.neboUrl': '或者一个网址：',
  'akt.textAktuality': '文章正文…',
  'akt.sdilejtePribeh': '把你的故事或经历分享给社群…',
  'akt.nahravam': '上传中…',
  'akt.publikovat': '发布',
  'akt.zkusenostiTucne': '社群成员的亲身经历。',
  'akt.zkusenostiPopis': '这个板块用来分享生活经历和故事。帖子可以有文字、图片或视频。',
  'akt.sdiletSvujPribeh': '分享我的故事',
  'akt.zadneAktuality': '没有消息',
  'akt.zadneVKategorii': '这个分类里还什么都没有',
  'akt.publikovan': '帖子已发布。',
  'akt.chybaPublikovat': '没能发布',
  'akt.opravduSmazat': '要删掉这条帖子吗？',
  'akt.chyba': '出了点问题',
  'akt.chybaKomentar': '评论没能添加',
  'akt.chybaSmazatKomentar': '评论没能删除',
  'akt.aktualizovan': '帖子已更新。',
  'obecne.smazat': '删除',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': '我在考虑过渡',
  'faze.thinking.popis': '我在弄清楚自己是谁，哪条路是我的。',
  'faze.research': '我在找信息',
  'faze.research.popis': '看资料、问问题、找来源和社群。',
  'faze.therapist': '第一次去看治疗师',
  'faze.therapist.popis': '我在和专业人士聊我的路。',
  'faze.hormones': '激素治疗',
  'faze.hormones.popis': '我在开始或继续激素治疗。',
  'faze.documents': '更改证件',
  'faze.documents.popis': '我在办姓名或性别的法律变更。',
  'faze.cosmetic': '外表和打理',
  'faze.cosmetic.popis': '我在打理自己的样子——头发、妆容、风格。',
  'faze.surgery-thinking': '我在考虑手术',
  'faze.surgery-thinking.popis': '我在权衡各种手术方案。',
  'faze.surgery': '手术之后',
  'faze.surgery.popis': '我做过一次或多次手术。',
  'faze.stable': '稳定下来了',
  'faze.stable.popis': '我已经在我想在的地方，过我的日子。',
  'faze.individual': '我自己的路',
  'faze.individual.popis': '我的路不属于任何一个格子——这也挺好。',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': '故事就分享在这里。',
  'zk.pribehNenalezen': '找不到这个故事',
  'zk.zpetNaPribehy': '回到故事',
  'zk.komunita': '社群',
  'zk.pribeh': '故事',
  'zk.upravitPribeh': '修改故事',
  'zk.upravtePribeh': '修改你分享的故事。',
  'zk.textPribehu': '故事正文…',
  'zk.fazeTranzice': '过渡阶段',
  'zk.neuvadet': '不说',
  'zk.ukazeSeLidem': '这个故事会展示给正在读那个阶段指南的人。',
  'zk.sdiletPribeh': '分享一个故事',
  'zk.overEmail': '确认你的邮箱才能分享故事',
  'zk.zadnePribehy': '还没有故事。来做第一个。',
  'zk.nazevPribehu': '你的故事的标题…',
  'zk.pribehP': '故事 *',
  'zk.sdilejteZkusenost': '把你的经历分享给社群…',
  'zk.chybaNacist': '故事没能加载',
  'zk.vyplnteNadpis': '标题和正文都要填',
  'zk.spatnyOdkaz': '图片链接要以 http://、https:// 或 / 开头',
  'zk.sdilen': '故事已分享。',
  'zk.chybaSdilet': '没能分享',
  'zk.opravduSmazat': '要删掉这个故事吗？',
  'zk.smazan': '故事已删除',
  'zk.aktualizovan': '故事已更新。',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': '你的邮箱还没有确认。请确认一下。',
  'ram.odesilam': '发送中…',
  'ram.znovuOdeslat': '再发一次',
  'ram.chceteUpozorneni': '要不要在有新消息时收到提醒？',
  'ram.tedNe': '暂时不用',
  'ram.paticka': '© 2026 Bloom – 跨性别社群的私密空间',
  'ram.zasadyKomunity': '社群守则',
  'ram.prekladNeovereny': '还没有说这种语言的人读过这份翻译。如果哪里听着不对，告诉我们。',
  'ram.nahlasitProblem': '报告问题',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': '管理员',
  'ot.overenyPravnik': '经核实的律师',
  'ot.overenyOdbornik': '经核实的专业人士',
  'ot.odznakJinaZeme': (p) => `这个标识只在以下地方有效：${p.zeme}`,
  'ot.otazkyKomunity': '社群提问',
  'ot.pridatOtazku': '提个问题',
  'ot.novaOtazka': '新的提问',
  'ot.naCoSeZeptat': '你想问什么？',
  'ot.otazkaSeZobrazi': '你的问题会展示给其他成员，他们可以来回答。',
  'ot.otazkaP': '问题 *',
  'ot.oblastTema': '领域 / 主题',
  'ot.vseObecna': '随便什么（一般性问题）',
  'ot.odeslatOtazku': '发送问题',
  'ot.overEmail': '确认你的邮箱才能提问',
  'ot.zadneOtazky': '还没有提问。来做第一个。',
  'ot.hlasu': () => '票',
  'ot.odpovedi': () => '个回答',
  'ot.zadneOdpovedi': '还没有回答。',
  'ot.napisteOdpoved': '写个回答…',
  'ot.jenPravnici': '“法律帮助”里的问题由经核实的律师和管理员来回答。',
  'ot.smazatOtazku': '要删掉这个问题吗？',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': '提供和寻找',
  'cp.zadneNabidky': '没有内容',
  'cp.napsatZpravu': '写条消息',
  'cp.nahlasitUzivatele': '举报这个人',
  'cp.nahlasitKoho': (p) => `举报 ${p.kdo}`,
  'cp.popisteDuvod': '说说你为什么要举报。管理员会看到这份举报。',
  'cp.zustaneteAnonymni': '举报会送到管理员那里。你保持匿名。',
  'cp.duvodP': '理由 *',
  'cp.vybertDuvod': '选一个理由…',
  'cp.nevhodneChovani': '不当行为',
  'cp.falesnyProfil': '虚假资料',
  'cp.jinyProblem': '其他问题',
  'cp.popisVolitelny': '描述',
  'cp.volitelny': '（可填可不填）',
  'cp.popisteSituaci': '把情况说得更详细一点…',
  'cp.odeslatNahlaseni': '发送举报',
  'cp.vyberteDuvodChyba': '请选一个举报理由',
  'cp.nahlaseniOdeslano': '举报已经发给管理员了',
  'cp.chybaNahlaseni': '举报没能发出去',
  'gal.chranenoHeslem': '有密码保护',
  'gal.soukromi': '隐私',
  'gal.nahravam': '上传中…',
  'gal.pridatFotku': '添加照片',
  'gal.nastaveniSoukromi': '相册的隐私设置',
  'gal.verejna': '公开',
  'gal.chranenaHeslem': '有密码保护',
  'gal.jeChranena': '这个相册有密码保护',
  'gal.zadneFotky': '还没有照片。加上第一张吧。',
  'gal.otagovat': '标记一位成员',
  'gal.hledatUzivatele': '搜索成员…',
  'gal.odemcena': '相册已解锁',
  'gal.spatneHeslo': '相册密码不对',
  'gal.nastaveniUlozeno': '相册设置已保存',
  'gal.fotkaNahrana': '照片已上传。',
  'gal.chybaNahrat': '照片没能上传',
  'gal.fotkaSmazana': '照片已删除',
  'gal.jizOtagovan': '这位成员已经被标记过了',
  'gal.otagovan': (p) => `已标记：${p.kdo}`,
  'gal.chybaTag': '标记没能添加',

  'ram.povolit': '允许',
  'ram.oProjektu': '关于项目',
  'ram.kontakt': '联系',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': '世界地图 – 点一个国家就能打开它',
  'mapa.priblizit': '放大',
  'mapa.oddalit': '缩小',
  'mapa.celySvet': '回到整个世界',
  'mapa.chybaNacteni': '地图没能加载',
  'mapa.chybaZkusteSeznam': '地图没能加载。试试下面的国家列表。',
  'mapa.teprveRoste': 'Bloom 在这里才刚开始',
  'mapa.napovedaDotyk': '拖动可以移动地图；两指张开、连点两下或用按钮都能放大。你不一定要用它——下面有搜索和完整的国家列表。',
  'obsah.specialists': () => '位专业人士',
  'obsah.organizations': () => '个组织',
  'obsah.events': () => '个活动',
  'obsah.pageants': () => '场比赛',
  'obsah.resources': () => '条资料',
  'obsah.zaznamu': (p) => `${p.pocet} 条记录`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': '你的家在哪里？',
  'domov.popis': '这样 Bloom 就会给你看离你近的东西。你想逛哪个国家都行——那不会改变'
      + '你的家乡国家。这一项从不公开，你也随时可以改。',
  'domov.preskocit': '跳过',
  'domov.najitZemi': '找一个国家…',
  'domov.nicNeodpovida': '没有匹配的。换个词试试。',
  'domov.klikniDoMapy': '你也可以直接点上面地图里的国家。',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': '帖子',
  'typ.users': '成员',
  'typ.specialists': '专业人士',
  'typ.services': '互助信息',
  'typ.articles': '法律帮助',
  'typ.questions': '社群提问',
  'typ.reviews': '对专业人士的评价',
  'nav.emailNeoveren': '邮箱未确认',
  'nav.neovereny': '未确认',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': '有东西坏了',
  'chyba.navrh': '一个建议',
  'chyba.bezpecnost': '安全问题',
  'chyba.jiny': '其他事情',
  'chyba.vyberteTyp': '请选一下问题的类型',
  'chyba.popisteProsim': '请描述一下问题',
  'chyba.odeslano': '报告已发送，谢谢。',
  'chyba.chybaOdeslat': '报告没能发出去',
  'chyba.napisteNam': '跟我们说说发生了什么——这能帮我们修好它。',
  'chyba.typProblemu': '问题类型',
  'chyba.popisProblemu': '发生了什么',
  'chyba.popisPriklad': '说说发生了什么、你本来期待什么、实际又发生了什么…',
  'chyba.priloha': '我们会自动附上：当前页面、时间，以及关于你浏览器的信息。',
  'chyba.odeslatHlaseni': '发送报告',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': '写点内容…',
  'ed.tucne': '加粗（Ctrl+B）',
  'ed.kurziva': '斜体（Ctrl+I）',
  'ed.odrazky': '项目符号列表',
  'ed.vlozitOdkaz': '插入链接',
  'ed.vlozitTabulku': '插入表格',
  'ed.radky': '行',
  'ed.sloupce': '列',
  'ed.vlozit': '插入',
  'ed.barva.cerna': '黑色',
  'ed.barva.seda': '灰色',
  'ed.barva.fialova': '紫色',
  'ed.barva.ruzova': '粉色',
  'ed.barva.modra': '蓝色',
  'ed.barva.zelena': '绿色',
  'ed.barva.cervena': '红色',
  'ed.barva.oranzova': '橙色',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': '这个确认链接无效。',
  'over.hotovo': '你的邮箱已确认。',
  'over.odkazVyprsel': '确认链接无效或已过期。',
  'over.overuji': '正在确认你的邮箱…',
  'over.cekejte': '请稍等。',
  'over.overen': '邮箱已确认。',
  'over.plnyPristup': '现在 Bloom 里的一切你都能用了。',
  'over.prejitNaBloom': '去 Bloom',
  'over.selhalo': '确认没有成功',
  'over.zpetNaPrihlaseni': '回到登录',
  'oauth.ucetNenalezen': '找不到账号',
  'oauth.neexistujeGoogle': '这个 Google 账号还没有对应的 Bloom 账号。请先注册。',
  'oauth.neexistujeFacebook': '这个 Facebook 账号还没有对应的 Bloom 账号。请先注册。',
  'oauth.registrovatGoogle': '用 Google 注册',
  'oauth.registrovatFacebook': '用 Facebook 注册',
  'oauth.prihlasujiGoogle': '正在用 Google 登录…',
  'oauth.prihlasujiFacebook': '正在用 Facebook 登录…',
  'oauth.facebookSelhalo': 'Facebook 登录没有成功',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': '加载中…',
  'obecne.nezadano': '— 未填写 —',
  'obecne.neplatnaHodnota': '这个值无效。',
  'obecne.strankovani': '分页',
  'navrh.doplnteNazev': '请把名称填上。',
  'navrh.vyberteZemi': '请选一个国家。',
  'navrh.doplnte': (p) => `请填写：${p.co}。`,
  'kat.overenoZaznam': '已核实这条记录与实际相符',
  'kat.prihlaskyDo': (p) => `报名截止到 ${p.datum}`,

  'up.odznakAdmin': '管理员',

  'profil.zalozkaProfil': '资料',
  'profil.zalozkaGalerie': '相册',
  'pf.lokalita': '所在地',

  'cesta.legendaBarev': '颜色说明',

  'hled.pocetVysledku': (p) => `（${p.pocet} 条结果）`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': '金色长发',
  'avatar.fem-lavender': '紫色头发',
  'avatar.fem-peach': '齐刘海波波头',
  'avatar.fem-dark': '深色长发',
  'avatar.fem-straight': '红色头发',
  'avatar.fem-ponytail': '马尾',
  'avatar.masc-blue': '金色短发',
  'avatar.masc-teal': '凌乱的头发',
  'avatar.masc-gray': '灰白头发',
  'avatar.masc-short': '寸头',
  'avatar.nb-mint': '薄荷绿头发',
  'avatar.nb-lilac': '高丸子头',
  'avatar.nb-curly': '短卷发',
  'avatar.nb-sage': '及肩头发',
  'avatar.nb-mohawk': '莫西干头',
  'avatar.nb-undercut': '两侧剃短',
  'avatar.nb-shaved': '光头',
  'avatar.nb-glasses': '眼镜',
  'avatar.animal-cat': '猫',
  'avatar.animal-fox': '狐狸',
  'avatar.animal-rabbit': '兔子',
  'avatar.sym-flower': '花',
  'avatar.sym-butterfly': '蝴蝶',
  'avatar.sym-star': '星星',
  'avatar.custom': '上传我自己的照片',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': '一段时间没有操作，我们把你登出了。',
  'odhl.necinnostPopis': '没人在的时候，Bloom 不会让你一直登着。',
  'odhl.zaChvili': '我们马上就要把你登出',
  'odhl.zaChviliPopis': '随时碰一下屏幕或键盘，你就会保持登录。',

  'reg.avatarSymboly': '符号',

  'avatar.fem-bun': '发髻',
  'avatar.masc-navy': '络腮胡',
  'avatar.masc-brown': '侧分',
  'avatar.masc-goatee': '山羊胡',
  'avatar.nb-freckles': '雀斑',
  'avatar.animal-panda': '熊猫',
  'avatar.animal-owl': '猫头鹰',
  'avatar.sym-rainbow': '彩虹',
  'avatar.sym-heart': '心',
  'avatar.sym-lotus': '莲花（Bloom）',

  'reg.potvrditHeslo': '确认密码',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': '创建',
  'obecne.sdilet': '分享',
  'obecne.opravneni': '权限',
  'obecne.pristupGalerie': '上传照片需要访问你的相册。',
  'obecne.vsechnyRegiony': '所有地区',
  'obecne.cesko': '捷克',
  'obecne.odbornici': '专业人士',
  'obecne.zadnaZprava': '暂无消息',
  'ucet.vyplnteEmailHeslo': '请输入邮箱和密码',
  'ucet.spatneUdaje': '邮箱或密码不正确',
  'ucet.googleSelhalo': '使用 Google 登录失败',
  'ucet.skrytHeslo': '隐藏密码',
  'ucet.emailOveren': '邮箱验证成功。',
  'ucet.emailPriklad': 'you@email.com',
  'ucet.overeniSelhalo': '验证失败。',
  'ucet.overeniSelhaloZnovu': '验证失败，请重试。',
  'ucet.komunitniHesloPovinne': '社群密码为必填项',
  'ucet.zadejteKomunitniHeslo': '请输入社群密码…',
  'ucet.komunitniHesloPopis': 'Bloom 是一个私密空间。社群里的人可以把密码给你。',
  'ucet.prezdivkaMin3': '昵称至少需要 3 个字符',
  'ucet.vyplntePrezdivku': '请输入昵称',
  'ucet.vasePrezdivka': '你的昵称',
  'ucet.profilNeulozen': '无法保存个人资料',
  'ucet.anoZrusitProfil': '是的，删除我的个人资料',
  'heslo.min8': '密码至少需要 8 个字符',
  'heslo.maleP': '密码必须包含小写字母',
  'heslo.velkeP': '密码必须包含大写字母',
  'heslo.cislo': '密码必须包含数字',
  'heslo.specialni': '密码必须包含特殊字符',
  'heslo.specialniPriklad': '密码必须包含特殊字符（!@#$%）',
  'heslo.napoveda': '至少 8 个字符，含大写、数字、特殊字符',
  'profil.oSobe': '简单介绍一下你自己…',
  'profil.zajmenaOna': '她',
  'profil.zajmenaJine': '其他',
  'profil.doplnujiciText': '补充说明（选填）…',
  'profil.prikladOboru': '例如：整形外科、家事法…',
  'komunita.soukromiNadpis': '我们保护隐私',
  'komunita.soukromiText': '在 Bloom 分享的内容，留在 Bloom。',
  'komunita.podporaText': 'Bloom 关乎彼此扶持。',
  'komunita.neniObchod': 'Bloom 不是交易平台。',
  'komunita.zadneObtezovani': '任何形式的骚扰在 Bloom 都不被容许。',
  'komunita.oslovovani': '我们以每个人使用的名字和代词称呼对方。',
  'komunita.jakakolivEtapa': '无论你走到旅程的哪一步。',
  'prav.kategZdravi': '健康',
  'prav.kategPravni': '法律',
  'prav.kategSocialni': '社会',
  'ot.chybaOdpoved': '回答发送失败。',
  'ot.chybaOtazka': '提问发布失败。',
  'zk.napisteKomentar': '写下评论…',
  'zpr.chybaHlasova': '语音消息上传失败。服务器：',
  'zpr.chybaObrazek': '图片上传失败。服务器：',
  'pod.nabizim': '我提供',
  'pod.coHledate': '你在找什么？（例如：按摩、摄影…）',
  'pod.coNabizite': '你能提供什么？（例如：做饭、发型…）',
  'pod.lokalitaVolitelna': '地点（选填）',
  'pod.podrobnejsiPopis': '更详细的说明 *',
  'pod.vyplnteHledate': '请写下你在找什么。',
  'pod.vyplnteNabizite': '请写下你能提供什么。',
  'pod.vyplntePopis': '请填写说明。',
  'pod.zadnePrispevky': '你还没有发布内容。创建一个提供或需求吧。',
  'svet.vybratZemi': '选择国家',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': '提问',
  'ot.nadpis': '问答',
  'zk.pridat': '添加故事',
  'zk.novy': '新故事',
  'zk.smazat': '删除故事',
  'zk.zadne': '还没有故事。来当第一个分享的人吧。',
  'akt.zadne': '暂无动态。',
  'nav.clanky': '文章',
  'ucet.emailOdeslan': '邮件已发送',
  'ucet.komunitniHeslo': '社群密码',
  'ucet.nemateUcet': '还没有账号？注册',
  'ucet.muzetePrihlasit': '你现在可以登录了。',
  'ucet.zapomenutePopis': '输入你的邮箱，我们会发送重设密码的链接。',
  'profil.oMneVolitelne': '关于我（选填）',
  'profil.prezdivka': '昵称',
  'profil.telefonVolitelne': '电话（选填）',
  'cesta.poznamkaVolitelna': '个人备注（选填）',
  'okoli.vyberteLokalitu': '请在上方选择地点',
  'hled.nadpis': '搜索',
  'hled.popis': '在整个应用中搜索 — 用户、文章、故事、评价…',
  'hled.min2': '请输入至少 2 个字符进行搜索',
  'pod.vsechnySluzby': '所有服务',
  'domu.clenoveKomunity': '社群成员',
  'zpr.zadneKonverzaceHledat': '还没有对话。在上方搜索用户吧。',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': '他',
  'reg.zajmenaOni': 'TA（中性）',
  'reg.zajmenaOno': '它',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': '删除照片',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': '为相册设置密码',
  'reg.min3znaky': '至少 3 个字符',
  'reg.zopakujteHeslo': '再次输入密码',
  'hled.vBloom': '在 Bloom 中搜索…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': '编辑个人资料',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': '选择地区',
  'obecne.region': '地区',
  'gal.heslemChranena': '密码保护',
  'gal.hesloGalerie': '相册密码',
  'reset.nastavitHeslo': '设置密码',
  'reset.hesloObnoveno': '密码已重设。',
  'profil.nenalezen': '找不到该个人资料',
  'obecne.nebo': '或',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': '打开验证码应用，输入 Bloom 显示的六位数字。你也可以改用一个备用码。',
  'auth.sifrovaniNapoveda': '如果你在网页版开启了消息加密，应用暂时无法登录该账号。请在浏览器中使用 bloomapp.cz。',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': '显示密码',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': '要删除这张照片吗？',
  'dvf.zadejteKod': '请输入应用中的验证码',
  'sif.odemknoutAplikaci': '解锁应用',
  'profil.odeslatZnovu': '重新发送',
};

export default zh;
